// @flow

import * as React from "react"
import Bio from "./bio"
import SEO from "./seo"
import Sidebar from "./Sidebar"
import { Navigation, Footer } from "../../../js/site/layout"

type LayoutProps = {|
    title: string,
    description: string,
    sidebar?: boolean,
    showTitle?: boolean,
    children: React.Node,
|}

export default ({
    title,
    description,
    children,
    showTitle = true,
    sidebar = true,
}: LayoutProps) => {
    let header = null
    if (showTitle) {
        header = (
            <>
                <h1 className="main-heading">SimplyRETS blog</h1>
                <br />
                <Bio showLogo={false} />
            </>
        )
    }

    return (
        <>
            <SEO title={title} description={description} />
            <Navigation />
            <div className="global-wrapper">
                <main className="row">
                    {showTitle && (
                        <div className="col s12">
                            <header className="global-header">{header}</header>
                        </div>
                    )}
                    {sidebar ? (
                        <>
                            <div className="col s8">{children}</div>
                            <div className="col s4">
                                <Sidebar />
                            </div>
                        </>
                    ) : (
                        <div className="col s10 offset-s1">{children}</div>
                    )}
                </main>
            </div>
            <Footer />
        </>
    )
}
